import store from '../state/store'
import Vue from 'vue'

export default [
  {
    path: '/login',
    name: 'login', 
    component: () => import('./views/account/login') 
  }, 
  {
    path: '/login/:token',
    name: 'login', 
    component: () => import('./views/account/login'), 
  }, 
  {
    path: '/logout',
    name: 'logout',
    beforeEnter(){  
    store.dispatch("auth/logOut")  
    }, 
  },
  {
    path: '/',
    name: 'default',
    component: () => import('./views/anasayfa/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  },

  { 
    path: '/ofirma',
    name: 'firma', 
    component: () => import('./views/ofirma/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  },
  {
    path: '/omalzeme',
    name: 'malzeme', 
    component: () => import('./views/omalzeme/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  },
  {
    path: '/omalzemegrup',
    name: 'malzemegrup', 
    component: () => import('./views/omalzemegrup/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  },
  {
    path: '/satharcamabutce',
    name: 'harcamabutce', 
    component: () => import('./views/satharcamabutce/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  },
  {
    path: '/sattalepler',
    name: 'sattalepler', 
    component: () => import('./views/sattalep/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  },  
  {
    path: '/sattalepaddedit/:AddEdit', 
    name: 'talepadd', 
    component: () => import('./views/sattalep/addedit'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  }, 
  {
    path: '/sattalepaddedit/:AddEdit/:EditId', 
    name: 'talepedit', 
    component: () => import('./views/sattalep/addedit'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  }, 
  {
    path: '/satdosya', 
    name: 'dosyaislem', 
    component: () => import('./views/satdosya/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"] ){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  }, 
  {
    path: '/dosyaislemleri/:id', 
    name: 'dosyaislemleri', 
    component: () => import('./views/dosyaislemleri/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"] ){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  }, 
  {
    path: '/BirimButceHarcamalari', 
    name: 'BirimButceHarcamalari', 
    component: () => import('./views/harcamagirisi/Index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"] ){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  }, 
  {
    path: '/sattaleponay',
    name: 'taleponay', 
    component: () => import('./views/sattaleponay/index'),
    beforeEnter(to,from,next){ 
        if(store.getters.["auth/isAuth"]){
          next()
        }else{
          window.location=Vue.prototype.$config.LOGIN_URL
        }
    }
  },  
  {
    path: '/userroles',
    name: 'userroles', 
    component: () => import('./views/userroles/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  },
  {
    path: '/raporsatdosyafatura',
    name: 'raporsatdosyafatura', 
    component: () => import('./views/satraporlama/getsatdosyafatura'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  },
  {
    path: '/toplutalep',
    name: 'toplutalep', 
    component: () => import('./views/sattalep/toplutalep'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  },
  {
    path: '/ouserbirimyetki',
    name: 'ouserbirimyetki', 
    component: () => import('./views/ouserbirimyetki/index'), 
     beforeEnter(to,from,next){  
          if(store.getters.["auth/isAuth"]){
          next() 
          }else{
            window.location=Vue.prototype.$config.LOGIN_URL 
          }
     }
  }, 
  {
    path: '/yaklasikmaliyetgiris/:id', 
    name: 'yaklasikmaliyetgiris', 
    component: () => import('./views/yaklasikmaliyetgiris/index'), 
  }, 
  {
    path: '/yayinlananihaleler', 
    name: 'yayinlananihaleler', 
    component: () => import('./views/yayinlananihaleler/index'), 
  }, 
  {
    path: '/:Sessionkey/:Email',
    name: 'default',
    component: () => import('./views/anasayfa/index'),
 
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  }, 
  {
    path: '*',
    redirect: '404',
  }
  
]
